<template>
    <div class="contanier">
        <CorrectedData v-if="tabIndex === 1" :score_data="scoreData" :corrected_number="workData.length" />

        <el-row :gutter="20" v-if="workData.length > 0">
            <el-col :class="[
                'work-corrected',
                current === index && active ? 'spreat-wprk' : '',
            ]" :span="span" v-for="(item, index) in workData" :key="index"
                :style="{ width: cate == 1 ? 450 + 'px' : 97 + '%' }">

                <!-- 作业列表姓名、头像部分 -->
                <section @click="handleSpread(index)">
                    <header-list :user="!item.user ? item : item.user">
                        <i v-if="tabIndex !== 2 && cate == 1" :class="[
                            current === index && active
                                ? 'el-icon-arrow-down'
                                : 'el-icon-arrow-right',
                        ]"></i>
                    </header-list>
                </section>

                <!-- 提交的作业内容 -->
                <div class="correct-content" v-if="current === index && active">
                    <work-content :content="item.content" :audio="item.voice" :images="item.images" :imgSize="120"
                        :imgHeight="120" :isShowAudioPlayer="item.voice ? true : false"></work-content>
                    <div class="correct-time" v-if="tabIndex !== 2">
                        <span>{{ item.update_time }}</span>
                        <div @click="toCorrect(item.id, tabIndex)" v-if="cate == 1 && tabIndex === 0">
                            <img src="@/assets/housework/edit_blue.png" />
                            <!-- {{ cate == 1 ? (tabIndex === 0 ? '批改' : '修改') : '' }} -->
                            批改
                        </div>
                    </div>

                    <!-- 作业点评 -->
                    <div class="teacher-corrected" v-if="item.correct">
                        <div class="teacher-score">
                            <span>点评:</span>
                            <span>{{ item.correct.score }}</span>
                        </div>
                        <work-content :id="'correct'" :content="item.correct.content" :audio="item.correct.voice"
                            :images="item.correct.images" :imgSize="110" :imgHeight="110"
                            :isShowAudioPlayer="item.correct.voice ? true : false"></work-content>
                    </div>
                    <!-- </div> -->

                </div>
                <!-- </section> -->
            </el-col>
        </el-row>



    </div>
</template>

<script>
import WorkContent from "./WorkContent.vue"
import CorrectedData from "../components/CorrectedData.vue"
import HeaderList from "./HeaderList.vue"
export default {
    components: { WorkContent, CorrectedData, HeaderList },
    data () {
        return {
            active: false,
            current: undefined,
            cate: localStorage.getItem('cate')
        }
    },
    props: {
        workData: {
            type: Array,
            default: [],
        },
        tabIndex: {
            type: Number,
            default: 0
        },
        scoreData: {
            type: Object,
        },
        // 用于layout布局显示
        span: {
            type: Number,
            default: 10
        }
    },
    watch: {
        workData (val) {
            this.workData = val
            // console.log("批改数据该更新了：", val)
        },
        tabIndex (val, oldVal) {
            this.tabIndex = val
            this.active = false
        }
    },
    mounted () {
        if (this.cate == 2) {
            this.active = true
            this.current = 0
        }
    },
    methods: {
        handleSpread (index) {
            if (this.cate == 2 || this.tabIndex === 2) {
                return false
            }
            this.current = index
            this.active = !this.active
        },
        toCorrect (id) {
            this.$emit('housewoekCorrecting', id, this.tabIndex)
        }
    },
}
</script>

<style lang="scss" scoped>
.contanier {
    margin-left: 19px;
    // display: flex;
    // justify-content: space-between;
    // flex-wrap: wrap;
}

.work-section {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: baseline;
}

.work-corrected {
    flex-grow: 1;
    margin-top: 20px;
    margin-left: 24px;
    width: 448px;
    // 内容超出自动换行，以字母为分割
    word-break: break-all;
    padding: 16px;
    box-sizing: border-box;
    background: #f4f4f5;

    i {
        cursor: pointer;
    }

    .correcte-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // align-items: flex-start;
        height: 36px;
        line-height: 36px;


        .correct-left {
            img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                vertical-align: bottom;
            }
        }
    }

    .correct-content {
        margin-left: 32px;

        /deep/ .audio-mock-player {
            background: #fff;

            .closeicon {
                display: none;
            }
        }

        /deep/ .work-content-img {
            margin: 10px 4px 0;
        }

        .correct-time {
            display: flex;
            justify-content: space-between;
            margin: 20px 0 16px;
            font-size: 12px;
            color: #A5A5A5;

            div {
                cursor: pointer;
                color: #007AFF;

                img {
                    vertical-align: bottom;
                }
            }
        }

        // 点评
        .teacher-corrected {
            padding: 10px 20px 0;
            box-sizing: border-box;
            font-size: 14px;
            color: #262C31;
            background: #fff;

            .teacher-score {
                display: flex;
                justify-content: space-between;

                span:nth-child(2) {
                    font-size: 16px;
                    color: #FD5A38;
                }
            }

            /deep/ p {
                margin: 10px 0;
                color: #262C31;
            }

            /deep/ .audio-mock-player {
                background: #F5F5F5;
            }

        }
    }
}


.el-row {
    margin-bottom: 20px;

    // margin:0 20px 20px !important;
    &:last-child {
        margin-bottom: 0;
    }
}

.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/CorrectWork.vue